import React from 'react';

import { Box, IBoxProps } from '@adsk/alloy-react-box';
import theme, { type StyleProp } from '@adsk/alloy-react-theme';

import { formatPath } from '../../../helpers';
import { Task } from '../../types';

interface PlanTaskContextPathProps {
  task: Task;
  color?: string;
  style?: StyleProp;
}

const PlanTaskContextPath = ({
  task,
  color = 'charcoal600',
  style = theme.typography.caption,
}: PlanTaskContextPathProps) => {
  const calculateContextPath = () => {
    if (!task.plan?.name) {
      return null;
    }

    if (!task.parentTask?.name) {
      return task.plan.name;
    }

    const parentPath = [task.plan.name, task.parentTask.name];

    return formatPath(parentPath);
  };

  const contextPath = calculateContextPath();

  if (!contextPath) {
    return null;
  }

  return (
    <Box style={style} color={color as IBoxProps['color']}>
      {contextPath}
    </Box>
  );
};

export default PlanTaskContextPath;
